import { ScrollSectionTitle } from '@components/scroll-section-title';
import { Divider, Grid, GridSize, Typography } from '@material-ui/core';
import { indigo } from '@material-ui/core/colors';
import { createCFFTextAttr, createCFF, ContextFormField } from '@components/context-form-field';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ContentPosterField } from '../fields/content-poster.field';
import { ContentTypeField } from '../fields/content-type.field';

export const ContentBasicSection = () => {
  const { control } = useFormContext();
  const attributes = [
    createCFFTextAttr('original_title', 'Original Title', 'Title in original language (Optional)'),
  ];
  return (
    <>
      <ScrollSectionTitle
        id="basic-details"
        subTitle="Basic, essential details of the content, used in summaries."
        icon={<BallotRoundedIcon style={{ color: indigo[700] }} fontSize="large" />}>
        Basic Details
      </ScrollSectionTitle>
      <Divider />
      <br />
      <Grid container spacing={4}>
        <Grid
          item
          style={{
            textAlign: 'center',
            paddingLeft: '30px',
            paddingRight: '15px',
          }}>
          <ContentPosterField control={control} name="poster" />
          <br />
          <Typography color="textSecondary" variant="body2">
            Content Poster
          </Typography>
        </Grid>
        <Grid item xs>
          <ContextFormField label="Title" name="title" helperText="The title of the content." />
          <br />
          <br />

          <ContextFormField
            multiline
            rows={6}
            label="Overview"
            name="overview"
            helperText="A short synopsis of the content"
          />
          <br />
          <br />
          <Grid>
            {attributes.map((attr, idx) => (
              <Grid key={idx} item xs={12}>
                <ContextFormField {...attr} />
              </Grid>
            ))}
          </Grid>
          <br/>
          <br/>
          <Grid item xs={12}>
          <ContextFormField
            name="working_title"
            label="Working Title"
            helperText="Please enter working title."
          />
        </Grid>
          <br />
          <br />
          <Grid>
            <ContextFormField label="AKA" name="content_aka" helperText="Also known as." />
          </Grid>
        </Grid>

        <Grid item xs={4}>
          <ContentTypeField control={control} name="content_type" />
        </Grid>
      </Grid>
    </>
  );
};
